<template>
    <div class="row justify-content-center">

        <CheckLogin v-if="loginType === null" @checked="loginChecked" :default-login="login"/>
        <SmsLogin v-else-if="loginType === 'phone' && loginExists" :default-login="login"/>
        <SmsRegister v-else-if="loginType === 'phone' && !loginExists" :default-login="login" :default-name="username"/>
        <EmailLogin v-else-if="loginType === 'email' && loginExists" :default-login="login"/>
        <EmailRegister v-else-if="loginType === 'email' && !loginExists" :default-login="login" :default-name="username"/>

        <!--
        <div class="col-lg-5 col-md-7">
            <div class="">
                <div class=" px-lg-5 pt-lg-5 pb-lg-2">
                    <div class="login-header text-center mb-4">Вход/Регистрация</div>
                    <base-alert type="danger" v-if="error">{{error}}</base-alert>
                    <base-alert type="primary mt-5 mb-8" v-if="registeredUser">На Ваш адрес электронной почты
                        {{registeredUser.email}} было отправлено письмо с инструкциями. Зайдите в Вашу почту и
                        активируйте аккаунт.
                    </base-alert>
                    <form role="form" v-if="!registeredUser">

                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Введите E-mail или телефон"
                                    :error="fieldError('login')"
                                    addon-left-icon="ni ni-email-83"
                                    v-model="login">
                        </base-input>

                        <base-input v-if="!loginExists" class="input-group-alternative mb-3"
                                    placeholder="Ваше имя"
                                    :error="fieldError('name')"
                                    addon-left-icon="ni ni-hat-3"
                                    v-model="username">
                        </base-input>

                        <base-input v-if="!loginExists && loginType === 'phone'" class="input-group-alternative mb-3"
                                    placeholder="Код из СМС"
                                    :error="fieldError('code')"
                                    addon-left-icon="ni ni-hat-3"
                                    v-model="code">
                        </base-input>

                        <div class="row mt-4 mb-3" v-if="!loginExists">
                            <div class="col-12">
                                <base-checkbox class="custom-control-alternative danger"
                                               v-model="agree"
                                               :disabled="registeredUser">
                                    <span class="user-policy">Я ознакомился и согласен с условиями <a
                                            href="https://poliglotiki.com/polzovatelskoe-soglashenie.html"
                                            target="_blank">Пользовательского Соглашения и Политики Конфиденциальности</a></span>
                                </base-checkbox>
                                <base-checkbox class="mt-3 custom-control-alternative danger"
                                               v-model="agree2"
                                               :disabled="registeredUser">
                                    <span class="user-policy">Даю согласие на обработку персональных данных *</span>
                                </base-checkbox>
                            </div>
                        </div>
                        <div class="text-center">
                            <base-button
                                    data-model="user"
                                    data-action="check-login"
                                    data-label="Продожить"
                                    v-if="loginType == null" class="my-4 px-5 py-3 login-btn" @click="checkLogin">
                                Продолжить
                            </base-button>
                        </div>
                        <div class="text-center">
                            <base-button
                                    data-model="user"
                                    data-action="register-code"
                                    data-label="Next"
                                    v-if="loginType != null && loginExists" class="my-4 px-5 py-3 login-btn" @click="submitCode">
                                Подтвердить
                            </base-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        -->


        <div class="col-12" v-if="loginType !== null && !loginExists && flavorConfig.personalDataNotice">
            <div class="personal-notice text-center">
                *  {{ $t('personal_data_agree') }}
            </div>
        </div>


        <div class="col-12" v-if="loginType === null">
            <div class="row mt-1 justify-content-center">
                <SocialLogin/>
            </div>
        </div>
        <div class="col-12 text-center other-login"
             v-if="(loginType === null) || (loginType === 'email' && loginExists)">
            <router-link :to="recoveryLink()" class="text-light">
                {{ $t('forgot_password') }}
            </router-link>
        </div>

    </div>
</template>
<script>
    import {getUser} from "../data/jwt.service";
    import SocialLogin from "./SocialLogin";
    import CheckLogin from "./Auth/CheckLogin";
    import SmsLogin from "./Auth/SmsLogin";
    import SmsRegister from "./Auth/SmsRegister";
    import EmailLogin from "./Auth/EmailLogin";
    import EmailRegister from "./Auth/EmailRegister";
    import {isAndroid} from "../data/AndroidApi";


    export default {
        name: 'user-login-register',
        components: {SmsRegister, SmsLogin, CheckLogin, SocialLogin, EmailLogin, EmailRegister},
        data() {
            return {
                username: '',
                login: '',
                loginType: null,
                loginExists: false,

                error: null,
                fieldsErrors: [],
                loading: false,
            }
        },

        mounted() {
            if (getUser()) {
                this.$router.push('/user/profile')
            } else {
                console.log(this.$route.query)
                if ('login' in this.$route.query) this.login = this.$route.query.login
                if ('name' in this.$route.query) this.username = this.$route.query.name
            }
        },

        methods: {
            loginChecked(loginType) {
                this.login = loginType.login
                this.loginType = loginType.type
                this.loginExists = loginType.state === 'exists'
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
            recoveryLink() {
                if ('return' in this.$route.query) return '/user/recovery?return=' + this.$route.query.return
                return '/user/recovery'
            },
            isAndroidApp() {
                return isAndroid()
            },
        }
    }
</script>
<style scoped>
</style>
